@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';
@import '../../../constants/spacing.module.less';

.packing-slip-complete-editor {
  border: 1px solid @editor--packing-slip--border-color;
  margin: @space-8 0;

  .field-replacement-standalone-wrapper {
    display: flex;
    align-items: center;
    padding: @space-8;
  }

  .field-replacement-button {
    padding: @space-8;
    font-size: 14px;
    margin-right: @space-4;
  }

  .divider {
    width: 98%;
    border-bottom: 1px solid @editor--packing-slip--border-color;
    margin: 0 auto;
  }

  .editor-container {
    min-height: 100px;

    .cm-editor {
      min-height: 100px;
    }

    .cm-scroller {
      min-height: 100px;
    }
  }
}

.group-header {
  padding: 5px;
  font-size: 14px;
  color: @editor--header--text-color;
}
